<div class="special_permissions">
  <!--The Heading sections (Heading + Serach )-->
  <div class="row heading-background mt-5">

    <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
      <h4 (click)="showData ? hideData() : resetAll()"
        role="button"
        class ="clickable-cursor">
        <span [ngClass]="showData ? 'rotated' : 'not-rotated'">
          <mat-icon class="icon-color-fix ump-expand-section-icon">chevron_right</mat-icon>
        </span>
        Special Permissions
      </h4>
    </div>

    @if (showData) {
      <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 search-container">
        <button mat-raised-button (click)="funcGetSpecialPermissions()" aria-label="Reset" class="btn btn-sm button-fix button-color-fix-orange">
          <mat-icon class="icon-color-fix">cached</mat-icon>
        </button>
      </div>
    }
  </div>



  <!--List section-->

  @if (showData) {
    <div class="custom_small_panelbody_fix">
      @if (Response_State===1) {
        <div>
          <div class="row">
            <mat-selection-list (selectionChange)="itemSelected($event)">
              @for (entity of entities; track entity) {
                <mat-list-option [value]="entity.id"
                  checkboxPosition="before"
                  [selected]="entity.isSelected"
                  [disabled]=" entity.isInherited"
                  [ngStyle]="{'color': entity.isInherited === true ? 'grey' : '', 'background-color': entity.isInherited === true ? 'inherit' : 'inherit'}">
                  {{ entity.persona }}{{ entity.isInherited === true ? '(INHERITED)' : ''}}
                  @if (hasAdditionalCosts(entity.persona) === 1) {
                    <span style="color:greenyellow !important">$$</span>
                  }
                  @if (hasAdditionalCosts(entity.persona) === 0) {
                    <span style="color:greenyellow !important">$</span>
                  }
                </mat-list-option>
              }
            </mat-selection-list>
          </div>
        </div>
      }
      @if (Response_State===-1) {
        <div>
          <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 150px;">
            <p style="color: #ff3232; font-weight: 600;">ERROR: {{errorResponse}}</p>
          </div>
        </div>
      }
      @if (Response_State===-2) {
        <div style=" padding: 20px !important;">
          <div class="blackbg card__desc">
            @for (_ of [].constructor(6); track _) {
              <div class="card__desc-text"></div>
            }
          </div>
        </div>
      }
    </div>
  }


</div>



